<template>
  <div id="history" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>会社沿革</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">会社案内</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="company-layout">
        <CompanyNav active-key="history" />

        <div class="page-card">
          <p class="page-kicker">History</p>
          <h2>これまでの歩み</h2>
          <ul class="timeline-list">
            <li>
              <strong>2023.7</strong><br>
              長崎市長崎県にInnoSource株式会社設立
            </li>
          </ul>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';
import CompanyNav from '@/components/companyNav';

export default {
  name: 'history',
  components: {
    Top,
    Foot,
    CompanyNav,
  },
};
</script>
